import flatpickr from "flatpickr";
import { Portuguese } from "flatpickr/dist/l10n/pt.js"
import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect'
const toastr = require("toastr");
import "jquery-mask-plugin";

import { default as dark_mode } from './utils/dark_mode.js'

const Utils =  function($) {
  $(document).on("ready page:load turbolinks:load", function() {
    $.fn.select2.defaults.set("theme", "bootstrap4");
    $.fn.select2.defaults.set("language", "pt-BR");

    $('.currency').mask('000.000.000.000.000,00', {reverse: true})
    $('.phone').mask('(00) 0000-00009')
    $('.cpf').mask('000.000.000-00', {reverse: true})
    $('.cnpj').mask('00.000.000/0000-00', {reverse: true})

	dark_mode.init();

    let options = {
      onKeyPress: (value, e, field, options) => {
        let masks = ['000.000.000-00999', '00.000.000/0000-00'];
        let mask = masks[(value.length > 14 ? 1 : 0)];
        $('.cpf_cnpj').mask(mask, options);
      }
    };
    $('.cpf_cnpj').mask('000.000.000-00999', options);
	  $('.cpf_cnpj').blur( () => {
		  if (window.validaCpfCnpj($('.cpf_cnpj').val()) == false) {
			toastr.error('CPF/CNPJ inválido!', 'Erro!')
	  		$('.cpf_cnpj').focus();
			return false;
		 }
	  });

    $("#mail_body_sucess .trix-button-group-spacer").each(function(){
      this.innerHTML = "Nome = #NAME# | Usuáiro = #USER# | Senha = #PASSWORD#" ;
    });

    $("#mail_body_waiting_payment .trix-button-group-spacer").each(function(){
      this.innerHTML = "Nome = #NAME# | Link Boleto/PIX = #CHECKOUT_URL#" ;
    });

    $("select.select2").each(function(){
      var select2_field = $(this);
      if (select2_field.data('url')){
        // select2_field.select2({theme: "bootstrap4",language: "pt-BR"})
        window.poloni.utils.select2_ajax.select2_ajax_request.init(select2_field, {theme: "bootstrap4",language: "pt-BR"})
      } else {
        select2_field.select2()
      }
    })

    let cepOptions =  {
      onComplete: (cep, event, currentField) =>{

        let card = currentField.parents('.card')

        if (cep.length > 6){
          window.cep(cep).then( (value) => {
            card.find("[name$='[city]']").val(value.city)
            card.find("[name$='[address]']").val(value.street)
            card.find("[name$='[district]']").val(value.neighborhood)
            card.find("[name$='[state]']").val(value.state)
          }).catch(
            console.log('CEP não encontrado ou serviço indisponível.')
            // toastr.error('CEP não encontrado ou serviço indisponível.', 'Erro!')
          )
        }


      }
    }

    $('input.cep').unmask().mask('00000-000',cepOptions)

    flatpickr("input.date_picker", {dateFormat: 'd/m/Y', "locale": Portuguese })
    flatpickr("input.time_picker", {"locale": Portuguese, time_24hr: true, enableTime: true, noCalendar: true})

    let now = new Date
    flatpickr("input.month_picker", {"locale": Portuguese,
      minDate: now.getFullYear()+'-'+(now.getMonth()+1),
      plugins: [
        new monthSelectPlugin({
          shorthand: true, //defaults to false
          dateFormat: "m/Y", //defaults to "F Y"
          altFormat: "m/Y", //defaults to "F Y"
          theme: "light" // defaults to "light"
        })
      ]
    })


    toastr.options = {
      "closeButton": false,
      "debug": false,
      "newestOnTop": false,
      "progressBar": false,
      "positionClass": "toast-bottom-right",
      "preventDuplicates": false,
      "onclick": null,
      "showDuration": "500",
      "hideDuration": "1000",
      "timeOut": "10000",
      "extendedTimeOut": "1000",
      "showEasing": "swing",
      "hideEasing": "linear",
      "showMethod": "fadeIn",
      "hideMethod": "fadeOut"
    }

    const showToastType = {
      notice: 'success',
      success: 'success',
      alert: 'error',
      error: 'error',
      warning: 'warning',
      info: 'info'
    };

    const showToastOptions = {
      notice: {},
      alert: { "timeOut": "0", "extendedTimeOut": "0" },
      warning: { "timeOut": "0", "extendedTimeOut": "0" },
      info: {}
    };

	  window.validaCpfCnpj = function(val) {
      if (val.length == 14) {
          var cpf = val.trim();

          cpf = cpf.replace(/\./g, '');
          cpf = cpf.replace('-', '');
          cpf = cpf.split('');

          var v1 = 0;
          var v2 = 0;
          var aux = false;

          for (var i = 1; cpf.length > i; i++) {
              if (cpf[i - 1] != cpf[i]) {
                  aux = true;
              }
          }

          if (aux == false) {
              return false;
          }

          for (var i = 0, p = 10; (cpf.length - 2) > i; i++, p--) {
              v1 += cpf[i] * p;
          }

          v1 = ((v1 * 10) % 11);

          if (v1 == 10) {
              v1 = 0;
          }

          if (v1 != cpf[9]) {
              return false;
          }

          for (var i = 0, p = 11; (cpf.length - 1) > i; i++, p--) {
              v2 += cpf[i] * p;
          }

          v2 = ((v2 * 10) % 11);

          if (v2 == 10) {
              v2 = 0;
          }

          return (v2 == cpf[10]);
      } else if (val.length == 18) {
          var cnpj = val.trim();

          cnpj = cnpj.replace(/\./g, '');
          cnpj = cnpj.replace('-', '');
          cnpj = cnpj.replace('/', '');
          cnpj = cnpj.split('');

          var v1 = 0;
          var v2 = 0;
          var aux = false;

          for (var i = 1; cnpj.length > i; i++) {
              if (cnpj[i - 1] != cnpj[i]) {
                  aux = true;
              }
          }

          if (aux == false) {
              return false;
          }

          for (var i = 0, p1 = 5, p2 = 13; (cnpj.length - 2) > i; i++, p1--, p2--) {
              if (p1 >= 2) {
                  v1 += cnpj[i] * p1;
              } else {
                  v1 += cnpj[i] * p2;
              }
          }

          v1 = (v1 % 11);

          if (v1 < 2) {
              v1 = 0;
          } else {
              v1 = (11 - v1);
          }

          if (v1 != cnpj[12]) {
              return false;
          }

          for (var i = 0, p1 = 6, p2 = 14; (cnpj.length - 1) > i; i++, p1--, p2--) {
              if (p1 >= 2) {
                  v2 += cnpj[i] * p1;
              } else {
                  v2 += cnpj[i] * p2;
              }
          }

          v2 = (v2 % 11);

          if (v2 < 2) {
              v2 = 0;
          } else {
              v2 = (11 - v2);
          }

          return (v2 == cnpj[13]);
      } else {
          return (val.length == 0);
      }
    }


    window.showToast = function(messages){
      for(var i = 0; i < messages.length; i++ ){
        var msg = messages[i];
        try {
          toastr[showToastType[msg[0]]](msg[1], '', showToastOptions[msg[0]]);
        } catch(err) {
          toastr.info(msg[1], '', showToastOptions[msg[0]]);
        }
      }
    };

    $('#phone_number').on('cocoon:before-insert', function(e,task_to_be_added) {
      task_to_be_added.find('input.phone').mask('(00) 0000-00009')
      task_to_be_added.find('select.select2').select2()
    })

    $('#addresses').on('cocoon:before-insert', function(e,task_to_be_added) {
      task_to_be_added.find('input.cep').mask('00000-000',cepOptions)
      task_to_be_added.find('select.select2').select2()
    })

	let arrSelect2 = ['program_exercise', 'combo_strategies', 'combo_programs', 'person_combo', 'person_accessory', 'ex_days', 'days'];

	arrSelect2.forEach(item => {
		$('#' + item).on('cocoon:before-insert', function(e,task_to_be_added) {
		  task_to_be_added.find('select.select2').each(function(){
			var select2_field = $(this);
			if (select2_field.data('url')){
			  window.poloni.utils.select2_ajax.select2_ajax_request.init(select2_field, {theme: "bootstrap4",language: "pt-BR"})
			} else {
			  select2_field.select2()
			}
		  })
		})
	})

	$('#strategy_days').on('change', function(e, task_to_be_added){
		var days = e.target.value * 1;
		var current_days_form = $("#days .strategy-days-form")
		if (days > 7)
			days = 7;
		if (days < 0)
			days = 0;

		if (current_days_form.length == days)
			return;



		var current_length = current_days_form.length;
		while (current_length < days) {
			$("#add_day_button").trigger("click");
			current_length++;
		}

		while (current_days_form.length > days) {
			$(".rm_day_button").last().trigger("click");
			days ++;
		}

		var fields_day = $("#days .strategy-days-form .input-day");
		var counDayOff = 4 - 4 / days;
		fields_day.each((index, obj) => {
			if (fields_day.length <= 2) {
				obj.value = Math.pow(index + 1,2);
			} else {
				obj.value = (index + 1);
				if (((fields_day.length == 3) || (fields_day.length == 4)) && index > 1)
					obj.value = (index + 2);
			}
		});

	})

  });
}

export default Utils;
